import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withRouter, Link } from 'react-router-dom';
import ClassNames from 'classnames';
import { makeSelectAllowSignIn } from 'containers/Main/selectors';
import Mixpanel from 'utils/mixpanelService';
import Colors from 'utils/colors';
import _get from 'lodash/get';
import withSizes from 'react-sizes';
import IconButton from '@material-ui/core/IconButton';
import HeartEmptyIcon from 'components/SaveAsFavorite/images/heart-empty.svg';
import HeartFullIcon from 'components/SaveAsFavorite/images/heart-full-white.svg';
import _isNil from 'lodash/isNil';
import { getImageFile, fallbackImage, isBot } from 'utils/stringUtils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import RightArrowIcon from '../images/circle-right-arrow.svg';

const styles = theme => ({
  icon: {
    position: 'absolute',
    top: 7,
    right: 14,
    padding: 0,
    borderRadius: 0,
  },
  topic: {
    width: '100%',
    height: 105,
    display: 'inline-flex',
    position: 'relative',
    background: '#FFFFFF',
    boxShadow: '0 0 16px 0 rgba(0,0,0,0.17)',
    borderRadius: 3,
  },
  relatedTopics: {
    height: 81,
  },
  cardLink: {
    textDecoration: 'none',
    color: '#979797',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  lifeEventContainer: {
    paddingTop: 0,
  },
  title: {
    width: '100%',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 40 /* Fallback for non-webkit */,
    wordBreak: 'break-word',
  },
  subtitle: {
    flex: '2',
    display: 'flex',
    fontSize: 10,
    justifyContent: 'center',
    alignItems: 'flex-start',
    color: theme.palette.primary.main,
  },
  paddedSubtitle: {
    margin: 10,
  },
  titleHidden: {
    display: 'none',
  },
  learnMore: {
    color: Colors.link,
    textDecoration: 'none',
    marginTop: 5,
    fontSize: 15,
    fontWeight: 400,
  },
  heart: {
    width: 20,
  },
  wrapContent: {
    position: 'relative',
  },
  img: {
    width: '105px !important',
    borderTopLeftRadius: 3,
    borderBottomLeftRadius: 3,
    marginRight: 20,
    display: 'block',
  },
  relatedTopicImage: {
    width: '85px !important',
  },
  mobileImg: {
    display: 'block',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  mobileTitle: {
    width: '100%',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 40 /* Fallback for non-webkit */,
    wordBreak: 'break-word',
  },
  mobileTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 65,
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 11,
  },
  mobileImageWrapper: {
    display: 'block',
    width: '100%',
    height: 'auto',
    position: 'relative',
    overflow: 'hidden',
    padding: '100% 0 0 0',
  },
  mobileTopic: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    background: '#FFFFFF',
    boxShadow: '0 0 16px 0 rgba(0,0,0,0.09)',
    borderRadius: 3,
  },
  rightArrow: {
    position: 'absolute',
    top: 10,
    right: 9,
  },
});

class TopicCard extends React.Component {
  redirect = () => {
    const {
      fields: { title },
      location,
    } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: title,
      type: 'topic',
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
    });
  };

  render() {
    const {
      topicID,
      fields: { slug, title },
      classes,
      fields,
      types,
      saved,
      saveTopic,
      srcPage,
      isList,
      isMobile,
      allowSignIn,
      section,
    } = this.props;
    /* eslint-disable */
    const bot = isBot();
    const baseSlugUrl = `/topics/${slug}`;
    const redirectUrl = types ? `${baseSlugUrl}?types=${types}` : baseSlugUrl;
    const isBlogPage = section === 'blog-page';
    const hasTopicImage =
      !_isNil(_get(fields, 'image.fields.file.url')) ||
      !_isNil(_get(fields, 'imageUrl')) ||
      !_isNil(_get(fields, 'image.url'));
    const imgUrl = hasTopicImage ? getImageFile(fields) : fallbackImage;
    if (!isMobile || (isMobile && isList)) {
      return (
        <Grid
          item
          xs={12}
          key={slug}
          className={ClassNames(
            srcPage === 'favorites' && classes.wrapContent,
          )}
        >
          <Link
            to={redirectUrl}
            onClick={this.redirect}
            className={classes.cardLink}
          >
            <div className={ClassNames(classes.topic, isBlogPage ? classes.relatedTopics : undefined)}>
              <div>
                <LazyLoadImage height={isBlogPage ? 81 : 105} width={isBlogPage ? 85 : 105} src={imgUrl} className={ClassNames(classes.img, isBlogPage ? classes.relatedTopicImage : undefined)} alt="Topic" />
              </div>
              <div className={ClassNames(classes.textContainer)}>
                {isBlogPage && (
                  <img
                    src={RightArrowIcon}
                    alt=""
                    className={classes.rightArrow}
                  />
                )}
                {!isBlogPage && allowSignIn && saved && !bot && (
                  <IconButton
                    className={classes.icon}
                    onClick={e => saveTopic(topicID, fields, true, e)}
                    disableRipple
                  >
                    <img
                      src={HeartFullIcon}
                      alt="Full"
                      className={classes.heart}
                    />
                  </IconButton>
                )}
                {!isBlogPage && allowSignIn && !saved && !_isNil(saved) && !bot && (
                  <IconButton
                    className={classes.icon}
                    onClick={e => saveTopic(topicID, fields, false, e)}
                    disableRipple
                  >
                    <img
                      src={HeartEmptyIcon}
                      alt="Empty"
                      className={classes.heart}
                    />
                  </IconButton>
                )}
                <Typography
                  variant="h6"
                  align="left"
                  color="textSecondary"
                  className={classes.title}
                >
                  {title}
                </Typography>
              </div>
            </div>
          </Link>
        </Grid>
      );
    }
    return (
      <Grid item xs={12} key={slug}>
        <Link
          to={redirectUrl}
          onClick={this.redirect}
          className={classes.cardLink}
        >
          <div className={classes.mobileTopic}>
            <div className={classes.mobileImageWrapper}>
            <div>
              <LazyLoadImage width="100%" height="100%" src={imgUrl} className={classes.mobileImg} alt="Topic" />
            </div>
            </div>
            <div className={ClassNames(classes.mobileTextContainer)}>
              {isBlogPage && !bot && (
                <img
                  src={RightArrowIcon}
                  alt=""
                  className={classes.rightArrow}
                />
              )}
              {allowSignIn && saved && !isBlogPage && !bot && (
                <IconButton
                  className={classes.icon}
                  onClick={e => saveTopic(topicID, fields, true, e)}
                  disableRipple
                >
                  <img
                    src={HeartFullIcon}
                    alt="Full"
                    className={classes.heart}
                  />
                </IconButton>
              )}
              {allowSignIn && !saved && !_isNil(saved) && !isBlogPage && (
                <IconButton
                  className={classes.icon}
                  onClick={e => saveTopic(topicID, fields, false, e)}
                  disableRipple
                >
                  <img
                    src={HeartEmptyIcon}
                    alt="Empty"
                    className={classes.heart}
                  />
                </IconButton>
              )}
              <Typography
                variant="h6"
                align="left"
                color="textSecondary"
                className={classes.mobileTitle}
              >
                {title}
              </Typography>
            </div>
          </div>
        </Link>
      </Grid>
    );
  }
}

TopicCard.propTypes = {
  topicID: PropTypes.string,
  fields: PropTypes.object,
  saved: PropTypes.bool,
  onlyCards: PropTypes.bool,
  saveTopic: PropTypes.func,
  classes: PropTypes.object,
  isLifeEvent: PropTypes.bool,
  location: PropTypes.object,
  history: PropTypes.object,
  height: PropTypes.number,
  types: PropTypes.string,
  srcPage: PropTypes.string,
  isMobile: PropTypes.bool,
  allowSignIn: PropTypes.bool,
  isList: PropTypes.object,
  section: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
});

const withConnect = connect(mapStateToProps);

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 600,
});

export default compose(
  withStyles(styles),
  withSizes(mapSizesToProps),
  withConnect,
  withRouter,
)(TopicCard);
